import { render, staticRenderFns } from "./CvCourse.vue?vue&type=template&id=08bd194c&scoped=true"
import script from "./CvCourse.vue?vue&type=script&lang=js"
export * from "./CvCourse.vue?vue&type=script&lang=js"
import style0 from "./CvCourse.vue?vue&type=style&index=0&id=08bd194c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bd194c",
  null
  
)

export default component.exports